export default class {
    
    /*@ngInject*/
    constructor($http, UTIL_URL){
        Object.assign(this, {$http, UTIL_URL});
    }
    
    getSlides(){
        return this.$http.get(`${this.UTIL_URL}/slides`);
    }
    
    actualizarSlide(id, destino){
        return this.$http.put(`${this.UTIL_URL}/slides/${id}`, destino);
    }

    borrarSlide(id){
        return this.$http.delete(`${this.UTIL_URL}/slides/${id}`);
    }

    getOfertas(){
        return this.$http.get(`${this.UTIL_URL}/ofertas`);
    }

    actualizarOferta(id, destino){
        return this.$http.put(`${this.UTIL_URL}/ofertas/${id}`, destino);
    }

    borrarOferta(id){
        return this.$http.delete(`${this.UTIL_URL}/ofertas/${id}`);
    }

    getDestacados(){
        return this.$http.get(`${this.UTIL_URL}/destacados`);
    }

    agregarDestacado(codigo){
        return this.$http.post(`${this.UTIL_URL}/destacados/${codigo}`);
    }

    borrarDestacado(id){
        return this.$http.delete(`${this.UTIL_URL}/destacados/${id}`);
    }
}


// WEBPACK FOOTER //
// ./client/app/configuracion-route/configuracion.service.js